import Thunk from 'src/thunks/index';
import { Data } from 'src/interfaces/general';
import userAssignmentFileAction from 'src/store/model/user_assignment_file';

const user_assignment_file = new Thunk('homeworks');

export type UserAssignmentFilePayload = Partial<Model.UserAssignmentContent>;

export const createUserAssignmentFile = user_assignment_file.create<
  Data<Model.UserAssignmentContent>,
  UserAssignmentFilePayload
>({
  onSuccess({ dispatch, data, args }) {
    dispatch(userAssignmentFileAction.updateEntity({ ...data.data, ...args }));
  },
});

export const updateUserAssignmentFile = user_assignment_file.update<
  Data<Model.UserAssignmentContent>,
  UserAssignmentFilePayload
>({
  onSuccess({ dispatch, data }) {
    dispatch(userAssignmentFileAction.updateEntity(data.data));
  },
});

export const deleteUserAssignmentFile = user_assignment_file.remove<
  void,
  UserAssignmentFilePayload
>({
  onSuccess({ dispatch, args }) {
    dispatch(userAssignmentFileAction.removeEntity(args));
  },
});
